import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import camelCaseKeys from 'utils/camelCase'
import fetch from 'isomorphic-fetch'

/**
 * Naive imlpementation that expects json response type and and can only GET data
 * Use at own risk, you have been warned!
 *
 * TODO: Replace isomorphic-fetch with a library that supports AbortController so we can abort any pending requests when the comopnent unmounts
 */
export default function useFetch(path) {
  const apiBaseUrl = useSelector((state) => state.config.urls.api)
  const bearerToken = useSelector((state) => state.authentication.bearerToken)

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [data, setData] = useState(null)

  useEffect(() => {
    let ignore = false

    setError(false)
    setLoading(true)

    async function fetchData() {
      try {
        const response = await fetch(`${apiBaseUrl}/${path}`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        })
        const responseData = await response.json()
        if (!ignore) {
          setData(camelCaseKeys(responseData, { deep: true }))
        }
      } catch (e) {
        if (!ignore) {
          setError(e)
        }
      } finally {
        if (!ignore) {
          setLoading(false)
        }
      }
    }
    fetchData()

    return () => {
      ignore = true // Tells us  that we shouldn't run any state updates
    }
  }, [apiBaseUrl, bearerToken, path])

  return [loading, error, data]
}
